import { EconomicsContainer } from '../containers/EconomicsContainer';
import { ForecastContainer } from '../containers/ForecastContainer';
import { ProjectsContainer } from '../containers/ProjectsContainer';
import { WellsContainer } from '../containers/WellsContainer';
import { FBAContainer } from '../containers/FBAContainer';
import { RTFOContainer } from '../containers/RTFOContainer';
// import { AnalyticsContainer } from '../containers/AnalyticsContainer';

const HomeComponent = () => {
  return (
    <ProjectsContainer />
  );
};

const WellsComponent = () => {
  return (
    <WellsContainer />
  );
};

const ForecastComponent = () => {
  return (
    <ForecastContainer />
  );
};

const EconomicsComponent = () => {
  return (
    <EconomicsContainer />
  );
};

const FBAComponent = () => {
  return (
    <FBAContainer />
  );
};

const RTFOComponent = () => {
  return (
    <RTFOContainer />
  );
};

// const AnalyticsComponent = () => {
//   return (
//     <AnalyticsContainer />
//   );
// };

// const OptimizationComponent = () => {
//   return (
//     <h2>Economics</h2>
//   );
// };

const Routes = [
  {
    path: '/',
    sidebarName: 'Home',
    component: HomeComponent
  },
  {
    path: '/wells',
    sidebarName: 'Wells',
    component: WellsComponent
  },
  {
    path: '/forecast',
    sidebarName: 'Forecast',
    component: ForecastComponent
  },
  {
    path: '/economics',
    sidebarName: 'Economics',
    component: EconomicsComponent
  },
  {
    path: '/fba',
    sidebarName: 'FBA',
    component: FBAComponent
  },
  {
    path: '/rtfo',
    sidebarName: 'RTFO',
    component: RTFOComponent
  }
  // {
  //   path: '/analytics',
  //   sidebarName: 'Analytics',
  //   component: AnalyticsComponent
  // }
];

export default Routes;